"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _organization = require("@/api/system/organization");
var _default = exports.default = {
  associate: {
    serviceMethod: function () {
      var _serviceMethod = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(key) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = key;
              _context.next = _context.t0 === 'dept' ? 3 : 4;
              break;
            case 3:
              return _context.abrupt("return", (0, _organization.selectDeptAss)({
                key: key,
                keyword: ''
              }).then(function (res) {
                return res.data;
              }));
            case 4:
              return _context.abrupt("return", []);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function serviceMethod(_x) {
        return _serviceMethod.apply(this, arguments);
      }
      return serviceMethod;
    }()
  }
};